import React from "react";
import Hero from "./components/Hero";
import Featured from "./components/Featured";
import About from "./components/About";
import Gallery from "./components/Gallery";
import "./About.css";
import FooterAbout from "./components/FooterAbout";
import Headers from "../components/Headers";

const AboutUs = () => {
  return (
    <>
      <Headers />
      <Hero />
      <About />
      {/* <Gallery /> */}
      {/* <Featured /> */}
      <FooterAbout />
    </>
  );
};

export default AboutUs;
